import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import { MouseEvent } from 'react';
import { isNil } from 'lodash';

import { getDomain } from '@/public/utils/url';

import { getFootnoteListId, getFootnoteRefId } from './utils';

import styles from './footnote.module.scss';

export interface FootnoteAttributes {
  href: string;
  label?: string;
  citeId: string;
  num: number;
}

export const Footnote = ({ node }: NodeViewProps) => {
  const attrs = node.attrs as FootnoteAttributes;
  const { label, citeId, href, num } = attrs;
  const domain = isNil(href) || href.length === 0 ? null : getDomain(href);

  if (domain === null) {
    return null;
  }

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation(); // Prevent selecting cell

    // Expand footnotes list and scroll to relevant item
    event.preventDefault();
    const target = document.querySelector(`#${getFootnoteListId(citeId)}`);

    if (target) {
      const detailsElement = target.closest('details');
      if (detailsElement && !detailsElement.open) {
        detailsElement.open = true;
      }
      target?.scrollIntoView();
    }
  };

  return (
    <NodeViewWrapper className={styles.footnote}>
      <a
        id={`${getFootnoteRefId(citeId)}`}
        href={`#${getFootnoteListId(citeId)}`}
        aria-describedby="footnote-label"
        title={label}
        onClick={handleClick}
        data-num={num}
      />
    </NodeViewWrapper>
  );
};
